import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from '../scenes.scss';

import ConclusionList from '../../components/conclusionList/conclusionListComponent';
import ConclusionButtons from '../../components/conclusionButtons/conclusionButtonsComponent';
import resolveTotalPrice from '../../services/helper/resolvePrice';

function ConclusionScene(props) {

    const { configuration } = props;
    const resolvePrice = (part) => resolveTotalPrice(
        part, part.serial_parent_uid, configuration
    );

    return (
        <div className={style.scene}>
            <ConclusionButtons />

            <ConclusionList item={configuration.engine} itemsList={null} label={t`Motor`} resolvePrice={resolvePrice} />
            <ConclusionList item={configuration.paintwork} itemsList={null} label={t`Lackierung`} resolvePrice={resolvePrice} />
            <ConclusionList item={null} itemsList={configuration.packs} label={t`Pakete`} resolvePrice={resolvePrice} />
            <ConclusionList item={null} itemsList={configuration.interior} label={t`Innenraum`} resolvePrice={resolvePrice} />
            <ConclusionList item={null} itemsList={configuration.basicvehicle} label={t`Sonderaustattung Basisfahrzeug`} resolvePrice={resolvePrice} />
            <ConclusionList item={null} itemsList={configuration.lastrada} label={t`Sonderausstattungen La Strada`} resolvePrice={resolvePrice} />
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration.configurations,
});

export default connect(mapStateToProps, null)(ConclusionScene);
